import React, { useState, useEffect } from "react";
import CreateSpeakerComponent from "../../components/CreateSpeakerComponent/CreateSpeakerComponent";
import { ADD_SPEAKER } from "../../GraphQL/Mutations";
import { useMutation } from "@apollo/client";
import { uploadFile } from "../../services/FileManager";
import { NotificationManager } from "react-notifications";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { clientWellness } from "../../App";

const CreateSpeakerContainer = ({ cancelFn, setShowCreateSpeaker }) => {
  const [showLoader, setshowLoader] = useState(false);
  const [fileName, setFileName] = useState();
  const [dataSpeaker, setDataSpeaker] = useState();
  const [runAddSpeaker] = useMutation(ADD_SPEAKER, { client: clientWellness });

  let handleCreateSpeaker = (speaker, file) => {
    runAddSpeaker({
      variables: {
        input: {
          speakerName: speaker?.FirstName,
          email: speaker?.Email,
          position: speaker?.Position,
          description: speaker?.Description,
          company: speaker?.Company,
          photo: file ? file : "",
          country: speaker?.Country,
        },
      },
    })
      .then((response) => {
        setshowLoader(false);
        if (response?.data?.addSpeaker?.idSpeaker) {
          NotificationManager.success("Speaker created successfully", "", 5000);
          setShowCreateSpeaker(false);
        } else {
          NotificationManager.warning(response.errors[0].message, "", 5000);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const createNewSpeaker = (speaker, folderName) => {
    setshowLoader(true);
    if (speaker.file) {
      uploadFile([speaker.file], folderName)
        .then((imageName) => {
          let arrayNames = JSON.parse(imageName);
          setFileName(arrayNames[0].newName);
          handleCreateSpeaker(speaker, arrayNames[0].newName);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      handleCreateSpeaker(speaker);
      setFileName("");
    }
    setDataSpeaker(speaker);
  };
  return (
    <>
      <CreateSpeakerComponent
        createNewSpeaker={createNewSpeaker}
        action={"add"}
        cancelFn={cancelFn}
      ></CreateSpeakerComponent>
      {showLoader && <ModalLoader></ModalLoader>}
    </>
  );
};
export default CreateSpeakerContainer;
